import {DOCUMENT, Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ScriptLoaderService {
  loader: { [url: string]: ReplaySubject<void> } = {};

  constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  loadScript(url: string): Observable<void> {
    if (this.loader[url]) {
      return this.loader[url].asObservable();
    }

    this.loader[url] = new ReplaySubject();

    const script = this.document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.onload = () => {
      this.loader[url].next();
      this.loader[url].complete();
    };

    this.document.body.appendChild(script);

    return this.loader[url].asObservable();
  }

  loadScriptWithIntegrity(url: string, integrity: string): Observable<void> {
    if (this.loader[url]) {
      return this.loader[url].asObservable();
    }

    this.loader[url] = new ReplaySubject();

    const script = this.document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.integrity = integrity;
    script.crossOrigin = 'anonymous';

    script.onload = () => {
      this.loader[url].next();
      this.loader[url].complete();
    };

    script.onerror = (error) => {
      console.error(`Script loading failed for ${url}:`, error);
      this.loader[url].error(new Error(`Failed to load script with integrity: ${url}`));
    };

    this.document.body.appendChild(script);

    return this.loader[url].asObservable();
  }
}
